import { Trait } from '../../trait.type';
import { TraitRegistry, TraitType } from '../../trait-registry';
import { invokeDie } from '../../die.type';
import { DieFace } from '../../face.type';

export class BladestormTrait extends Trait {
  static baseType = TraitType.Bladestorm;
  static baseTitle = 'Bladestorm';
  static baseText = 'Every third attack, invoke a shiv.';
  static baseIcon = 'trait';

  type = BladestormTrait.baseType;
  title = BladestormTrait.baseTitle;
  text = BladestormTrait.baseText;
  icon = BladestormTrait.baseIcon;

  init() {
    super.init();
    this.stacks = 0;
  }

  damageOut(damage: any): void {
    this.stacks++;
    if (this.stacks == 3) {
      invokeDie([DieFace.Shiv]);
      this.stacks = 0;
    }
  }
}

TraitRegistry.register(BladestormTrait.baseType, BladestormTrait);
